import 'css-chunksrc/client/pages/costProfilesPage/sidebar/styles.scss';export default {
  "header": "_header_t13je_1",
  "title": "_title_t13je_7",
  "button": "_button_t13je_14",
  "icon": "_icon_t13je_20",
  "costProfiles": "_costProfiles_t13je_30"
};